<template>
  <div class="pt-5">
    <Card>
      <template v-slot:title-panel> Datos de la solicitud </template>

      <div v-if="showActionsComp" class="botones-container">
        <template v-for="boton in botones">
          <v-btn
            v-if="boton.show"
            :key="boton.label"
            class="stats-button common-botton"
            dark
            :loading="loading"
            @click="boton.action"
          >
            <v-icon small class="mr-1">{{ boton.icon }}</v-icon>
            <span>{{ boton.label }}</span>
          </v-btn>
        </template>
      </div>

      <v-row>
        <v-col cols="3">
          <v-select
            v-if="isViewMode"
            :readonly="true"
            label="Estatus"
            :items="statusItems"
            v-model="solicitudLocal.statusId"
            item-text="text"
            item-value="value"
            outlined
            dense
          />
        </v-col>
        <v-col cols="9" v-if="showMotivoDetencion">
          <v-text-field
            label="Motivo detencion"
            v-model="solicitudLocal.motivo_detencion"
            :value="solicitudLocal.motivo_detencion"
            outlined
            color="#b11f1f"
            :readonly="true"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-form ref="firstStepForm" :lazy-validation="true">
        <v-row>
          <v-col cols="12" md="6" lg="3" xl="3">
            <v-select
              label="Tipo de redención"
              :items="tiposRedencion"
              v-model="solicitudLocal.tipo"
              placeholder="Requerido"
              :rules="requiredRule"
              outlined
              color="#b11f1f"
              :readonly="isViewMode || !!lockedTipo"
              :no-data-text="'No se encontraron resultados...'"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" lg="3" xl="3">
            <v-select
              label="Categorías de redención"
              :items="categoriasRedencion"
              v-model="solicitudLocal.categoria"
              placeholder="Requerido"
              :rules="requiredRule"
              outlined
              color="#b11f1f"
              :readonly="isViewMode || !!lockedHasEmision"
              :no-data-text="'No se encontraron resultados...'"
            ></v-select>
          </v-col>

          <v-col m="12" md="6" lg="3" xl="3">
            <v-select
              label="Beneficios o Asistencias"
              :items="beneficios"
              v-model="solicitudLocal.beneficioAsistencia"
              placeholder="Requerido"
              item-text="nombre"
              item-value="id"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
              :rules="requiredRule"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" lg="3">
            <v-text-field
              label="Tarjeta"
              v-model="tarjetaDisplay"
              type="text"
              outlined
              color="#b11f1f"
              :rules="[...requiredRule, tarjetaExacta]"
              readonly
            ></v-text-field>
          </v-col>

          <v-col m="12" md="6" lg="3" xl="3">
            <!-- <v-col cols="12" md="6">
              <v-autocomplete
                v-model="solicitudLocal.productoId"
                label="Club de beneficios y asistencias"
                :items="productosAdmitidos"
                item-value="id"
                item-text="producto_lead"
                outlined
                :rules="[$rules.required]"
                readonly
                hint="Se completará conforme el BIN de la tarjeta"
              ></v-autocomplete>
            </v-col> -->
            <v-autocomplete
              label="Club de beneficios y asistencias"
              :items="productosAdmitidos"
              v-model="solicitudLocal.productoId"
              placeholder="Requerido"
              item-text="producto_lead"
              item-value="id"
              outlined
              readonly
              color="#b11f1f"
              :rules="requiredRule"
              hint="Se completará conforme el BIN de la tarjeta"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="3" xl="3">
            <v-text-field
              v-if="isViewMode"
              label="Teléfono"
              :value="maskTelefono(solicitudLocal.celular)"
              outlined
              type="text"
              color="#b11f1f"
              readonly
            >
              <template v-slot:append>
                <v-tooltip top v-if="isTelefonoInListaNegra">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#b11f1f" v-bind="attrs" v-on="on">mdi-phone-off</v-icon>
                  </template>
                  <span>Este teléfono está en lista negra</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              v-else
              label="Confirmar teléfono"
              v-model="solicitudLocal.celular"
              outlined
              type="number"
              v-mask="'##########'"
              :rules="[...requiredRule, $rules.min(10), $rules.max(10)]"
              color="#b11f1f"
            ></v-text-field>
          </v-col>
          <v-col v-if="needDetalle" cols="12" md="12">
            <v-textarea
              v-model="solicitudLocal.detalle"
              label="Detalle (Número de cuenta - Número de Teléfono)"
              outlined
              :rules="requiredRule"
              color="#b11f1f"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="!isViewMode">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
            style="text-align: end"
          >
            <v-btn rounded dark class="common-botton" @click="checkBeforeSend">
              <span style="padding-right: 11%">Siguiente</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </Card>

    <SolicitudActions
      :modals="modals"
      :solicitud="solicitud"
      :folio="folio"
      :esRechazo="esRechazo"
      @choice="handleChoice"
      @close="handleClose"
      @showFolio="handleShowFolio"
    />
  </div>
</template>

<script>
import { reenviarSmsFolio } from "@/services/redencionService.js";
import { addTelefonoToListaNegra, validarExistenciaTelefonoEnListaNegra } from "@/services/listaNegraService.js";
import { getBeneficiosByProductoAseguradora, getBeneficiosList } from "@/components/clubBeneficios/clubBeneficiosService";
import { getBinesTarjetas } from "@/services/tarjetasService";
import { updateSolicitud } from "@/services/solicitudService";
import { getProductoById } from "@/components/productos/productosService";
import { getTarjetaInfo } from "@/services/tarjetasService";
import { mapState } from "vuex";

import Card from "@/components/commondComponents/Card.vue";
import SolicitudActions from "@/components/solicitudes/SolicitudActions.vue";

export default {
  components: {
    Card,
    SolicitudActions,
  },
  props: {
    mode: {
      type: String,
      default: "view", // 'create', 'edit', 'view'
    },
    // Mostrar o no las acciones de una solicitud CREADA
    showActions: {
      type: Boolean,
      default: false,
    },
    solicitud: {
      type: Object,
      default: () => ({}),
    },
    redencionLocal: {
      type: Object,
      default: () => ({}),
    },
    lockedTipo: {
      type: String,
      default: null, //'Redención Beneficio' o 'Redención Asistencia'
    },
    lockedHasEmision: {
      type: String, //'Redención Normal' o 'Redención sin Emisión'
      default: null,
    },
  },
  data() {
    return {
      solicitudLocal: {},
      tiposRedencion: ["Redención Asistencia", "Redención Beneficio"],
      categoriasRedencion: ["Redención Normal", "Redención sin Emisión", "Redención por Excepción"],
      beneficios: [],
      beneficiosList: [],
      currentProduct: null,
      club_beneficios: [],
      binesTarjetas: [],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      openModalEleccion: false,
      openModalRedencionManual: false,
      openModalMotivo: false,
      openDialogSolicitud: false,
      openModalValidateCode: false,
      showFolioModal: false,
      redimir: false,
      cancelar: false,
      redimirManual: false,
      redencionExcepcion: false,
      bypassCliente: false,
      esRechazo: false,
      agregarTelefonoListaNegra: false,
      isTelefonoInListaNegra: false,
      redencion: null,
      folio: "",
      currentRol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      canRedimirExcepcion: true,
      loading: false,
      showFolio: false,
      modals: {
        openEleccion: false,
        openRedencionManual: false,
        openMotivo: false,
        openSolicitud: false,
        openValidateCode: false,
        showFolio: false,
      },
      statusItems: [
        { value: 1, text: "Nueva" },
        { value: 2, text: "En trámite" },
        { value: 3, text: "Cerrada" },
        { value: 4, text: "Folio Solicitado" },
        { value: 5, text: "Folio Obtenido" },
        { value: 6, text: "Folio Enviado" },
        { value: 7, text: "Atención Manual" },
        { value: 8, text: "Cancelada" },
        { value: 9, text: "Pendiente de autorización" },
        { value: 10, text: "Asignada" },
        { value: 11, text: "Pendiente de información" },
      ],
    };
  },
  watch: {
    solicitud: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.solicitudLocal = JSON.parse(JSON.stringify(newVal || {}));
        if (this.lockedTipo) {
          this.solicitudLocal.tipo = this.lockedTipo;
        }
        if (this.lockedHasEmision) {
          this.solicitudLocal.categoria = this.lockedHasEmision;
        }
        if (this.solicitudLocal.beneficio_asistencia)
          this.solicitudLocal.beneficioAsistencia = this.solicitudLocal.beneficio_asistencia;
      },
    },
    async "solicitudLocal.productoId"(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.loadProducto();
      if (!this.isViewMode) await this.loadBeneficios();
    },
    redencionLocal: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.redencion = JSON.parse(JSON.stringify(newVal || {}));
      },
    },
    "solicitudLocal.tarjeta"() {
      this.changeProductoLead();
    },
    "solicitudLocal.tipo"(newVal) {
      this.filterAsistenciaBeneficio(newVal);
    },
  },
  computed: {
    ...mapState("permisos", ["permisos"]),

    isViewMode() {
      return this.mode === "view";
    },
    tarjetaDisplay: {
      get() {
        return this.maskTarjeta(this.solicitudLocal.tarjeta)
      },
      set(val) {
        this.solicitudLocal.tarjeta = val;
      }
    },
    showActionsComp() {
      return this.showActions === true;
    },
    esInbound() {
      return this.rol.includes("INBOUND");
    },
    requiredRule() {
      return this.isViewMode
        ? []
        : [
            (v) => {
              if (!v) return "El campo es requerido";
              if (typeof v === "object" && Object.keys(v).length === 0)
                return "El campo es requerido";
              return true;
            },
          ];
    },
    tarjetaExacta() {
      const digits = (this.solicitudLocal.tarjeta || "").toString().replace(/\D/g, "");
      return digits.length === 16 || "La tarjeta debe tener exactamente 16 dígitos";
    },

    showRedimirSolicitud() {
      return (
        this.redencion &&
        this.solicitudLocal?.statusId === 7
        )
    },
    showRedencionExcepcion() {
      return (
        this.solicitudLocal?.statusId != 9 &&
        this.permisos?.includes("FUN_REDENCION_POR_EXCEPCION") && this.currentProductoAseguradora != "Bradescard MAX"
      );
    },
    showAutorizarRedencion() {
      return (
        this.redencion &&
        this.solicitudLocal?.statusId == 9 &&
        this.permisos &&
        (this.permisos.includes(
          "FUN_APROBAR_O_RECHAZAR_REDENCIÓN_POR_EXCEPCIO",
        ) ||
          this.permisos.includes(
            "FUN_APROBAR_O_RECHAZAR_REDENCIÓN_POR_SIN_EMIS",
          )) &&
        this.canRedimirExcepcion && this.currentProductoAseguradora != "Bradescard MAX"
      );
    },
    showReenviarSMS() {
      return (
        this.redencion && this.permisos?.includes("FUN_REENVIO_DE_SMS_FOLIO")
      );
    },
    showAgregarFolioManual() {
      return (
        this.solicitudLocal?.statusId != 9 &&
        this.permisos?.includes("FUN_AGREGAR_FOLIO_MANUAL") &&
        this.currentRol !== "SUPASISTENCIAS" && this.currentProductoAseguradora != "Bradescard MAX"
      );
    },
    showVisualizarFolio() {
      return this.solicitudLocal?.statusId == 3 && this.canSeeFolio();
    },
    showRechazarSolicitud() {
      return (
        this.solicitudLocal?.statusId == 9 &&
        this.permisos &&
        (this.permisos.includes(
          "FUN_APROBAR_O_RECHAZAR_REDENCIÓN_POR_EXCEPCIO",
        ) ||
          this.permisos.includes(
            "FUN_APROBAR_O_RECHAZAR_REDENCIÓN_POR_SIN_EMIS",
          )) &&
        this.currentRol !== "SUPASISTENCIAS" && this.currentProductoAseguradora != "Bradescard MAX"
      );
    },
    botones() {
      return [
        {
          label: "Redimir solicitud",
          icon: "mdi-checkbox-marked-circle",
          show: this.showRedimirSolicitud,
          action: () => this.accionRedimirSolicitud(),
        },
        {
          label: "Redención por excepción",
          icon: "mdi-checkbox-marked-circle",
          show: this.showRedencionExcepcion,
          action: () => this.accionRedencionExcepcion(),
        },
        {
          label: "Autorizar redención",
          icon: "mdi-checkbox-marked-circle",
          show: this.showAutorizarRedencion,
          action: this.accionAutorizarRedencion,
        },
        {
          label: "Reenviar SMS folio",
          icon: "mdi-message",
          show: this.showReenviarSMS,
          action: this.reenviarFolio,
        },
        {
          label: "Agregar folio manual",
          icon: "mdi-pencil",
          show: this.showAgregarFolioManual,
          action: this.accionAgregarFolioManual,
        },
        {
          label: "Visualizar folio",
          icon: "mdi-eye",
          show: this.showVisualizarFolio,
          action: this.accionVisualizarFolio,
        },
        {
          label: "Rechazar solicitud",
          icon: "mdi-close-circle",
          show: this.showRechazarSolicitud,
          action: this.accionRechazarSolicitud,
        },
        {
          label: "Agregar teléfono a lista negra",
          icon: "mdi-close-circle",
          show: !this.isTelefonoInListaNegra,
          action: this.accionAgregarTelefonoListaNegra,
        },
      ];
    },

    currentSocioName() {
      return this.currentProduct?.producto_lead || "";
    },
    currentProductoAseguradora() {
      return this.currentProduct?.producto_aseguradora || "";
    },
    currentProductName() {
      if (!this.solicitudLocal.beneficioAsistencia) return "";

      const beneficio = this.beneficiosList.find(
        (e) => e.id == this.solicitudLocal.beneficioAsistencia,
      );

      return (
        beneficio?.nombre ||
        this.solicitudLocal.nombreAsistencia ||
        ""
      );
    },
    productosAdmitidos() {
      return this.currentProduct?.ramo === "ASISTENCIAS"
        ? [this.currentProduct]
        : [];
    },
    currentBeneficios() {
      return this.beneficiosList;
    },
    needDetalle() {
      if (
        String(this.currentProductName).includes("Didi") ||
        String(this.currentProductName).includes("Rappi") ||
        String(this.currentProductName).includes("Saldo Celular")
      )
        return true;
      else return false;
    },
    showMotivoDetencion() {
      const statusId = this.solicitudLocal?.statusId;
      const mustShowByStatus = [7, 8, 9].includes(statusId);
      const hasRedencionCerrada = this.redencion && statusId !== 3;
      const hasMotivo = Boolean(this.solicitudLocal?.motivo_detencion);

      return ( hasRedencionCerrada || mustShowByStatus ) && hasMotivo;
    },
  },
  async mounted() {
    await Promise.all([
      this.loadBines(),
      this.loadProducto(),
      this.checkIfTelefonoIsInListaNegra(),
    ]);
    await this.loadBeneficios();
  },
  methods: {
    async loadBines() {
      const bines = await getBinesTarjetas();
      this.binesTarjetas = bines.tarjetas;
    },
    async loadBeneficios() {
      this.loading = true;
      try {
        const body = {
          productoAseguradora: this.currentProductoAseguradora,
          downsell: !!this.currentProduct?.down_sell,
        }
        const response = this.isViewMode ? await getBeneficiosList() : await getBeneficiosByProductoAseguradora(body);
        this.beneficiosList = response.clubBeneficios;
        const tipoActual = this.solicitudLocal.tipo || this.lockedTipo;
        if (tipoActual) this.filterAsistenciaBeneficio(tipoActual);
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    async loadProducto() {
      if (!this.solicitudLocal?.productoId) return;
      this.loading = true;
      try {
        const response = await getProductoById(this.solicitudLocal.productoId);
        this.currentProduct = response.data.producto;
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    maskTarjeta(numero) {
      if (!numero) return "";
      const clean = numero.toString().replace(/\D/g, "");
      if (clean.length <= 4) return clean;

      const last4 = clean.slice(-4);
      const oculto = clean.slice(0, -4);
      const grupos = [];
      for (let i = 0; i < oculto.length; i += 4) {
        const largoGrupo = Math.min(4, oculto.length - i);
        grupos.push("*".repeat(largoGrupo));
      }
      grupos.push(last4);
      return grupos.join(" ");

    },
    maskTelefono(numero) {
      if (!numero) return "";
      const clean = numero.toString().replace(/\D/g, "");
      const last4 = clean.slice(-4);
      return clean.length > 4 ? `******${last4}` : clean;
    },
    accionRedimirSolicitud() {
      this.resetEstadosAccion();
      this.modals.openEleccion = true;
      this.redimir = true;
    },

    accionRedencionExcepcion() {
      this.resetEstadosAccion();
      this.modals.openSolicitud = true;
    },

    accionAutorizarRedencion() {
      this.resetEstadosAccion();
      this.modals.openMotivo = true;
      this.redencionExcepcion = true;
      this.bypassCliente = true;
      this.redimir = true;
    },

    accionAgregarFolioManual() {
      this.resetEstadosAccion();
      this.modals.openRedencionManual = true;
      this.redimirManual = true;
    },

    accionVisualizarFolio() {
      this.resetEstadosAccion();
      this.modals.openValidateCode = true;
    },

    accionRechazarSolicitud() {
      this.resetEstadosAccion();
      this.esRechazo = true;
      this.modals.openMotivo = true;
      this.cancelar = true;
    },
    async checkIfTelefonoIsInListaNegra() {
      if (!this.isViewMode || !this.solicitudLocal?.celular) return;
      try {
        const response = await validarExistenciaTelefonoEnListaNegra(this.solicitudLocal.celular);
        this.isTelefonoInListaNegra = response;
      } catch (error) {
        this.$toast.error("Error al validar la existencia del telefono en lista negra" + error.message + " contacta con un administrador para solucionar el problema.");
      }
    },
    accionAgregarTelefonoListaNegra() {
      this.resetEstadosAccion();
      this.modals.openEleccion = true;
      this.agregarTelefonoListaNegra = true;
    },

    resetEstadosAccion() {
      this.redimir = false;
      this.cancelar = false;
      this.redimirManual = false;
      this.redencionExcepcion = false;
      this.bypassCliente = false;
      this.agregarTelefonoListaNegra = false;
      this.esRechazo = false;

      Object.keys(this.modals).forEach((key) => {
        this.modals[key] = false;
      });
    },
    closeAllActions() {
      this.modals = {
        openEleccion: false,
        openRedencionManual: false,
        openMotivo: false,
        openSolicitud: false,
        openValidateCode: false,
        showFolio: false,
      };
      this.redimir = false;
      this.cancelar = false;
      this.redimirManual = false;
      this.redencionExcepcion = false;
      this.bypassCliente = false;
      this.esRechazo = false;
      this.agregarTelefonoListaNegra = false;
    },

    canSeeFolio() {
      const correctRol = [
        "ADMIN",
        "OPERADORSERVICIOS",
        "OPERACIONES",
        "SUPERVISOR",
        "COORDINADOR",
      ].includes(this.currentRol);
      if (correctRol) return true;
    },
    async reenviarFolio() {
      try {
        await reenviarSmsFolio(this.redencion.id);
        this.$toast.success(false);
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
    agregarToListaNegra() {
      this.loading = true;
      addTelefonoToListaNegra({
        telefono: this.solicitudLocal.celular,
        origen: "Portal",
        solicitudId: this.solicitudLocal.id,
      })
        .then(async () => {
          this.isTelefonoInListaNegra = await validarExistenciaTelefonoEnListaNegra(
            this.solicitudLocal.celular
          );
          this.$toast.success("Teléfono agregado a lista negra");
        })
        .catch((error) => {
          this.$toast.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
      this.closeAllActions();
    },
    userChoice(val, folio) {
      if (val && this.agregarTelefonoListaNegra) {
        return this.agregarToListaNegra();
      }
      if (val) {
        let body = this.redimir
          ? { redimirBeneficioAsistencia: true }
          : this.cancelar
          ? { status: 8 }
          : this.redimirManual
          ? { redimirBeneficioAsistencia: true, folioManual: folio }
          : {};
        if (this.redencionExcepcion) body.redencionExcepcion = true;
        if (this.bypassCliente) body.bypassCliente = true;
        this.loading = true;
        updateSolicitud(body, this.$route.params.idSolicitud).then((r) => {
          if (r.status == 200) {
            this.$toast.success(r.message);
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          } else {
            this.$toast.error(r.message);
            this.loading = false;
          }
        });
      }
      this.closeAllActions();
      setTimeout(() => {
        this.$router.go(0);
      }, 2000);
    },
    userChoiceMotivo(val, motivo) {
      if (val) {
        const body = {
          ...(this.cancelar && {
            status: 8,
            motivo,
          }),
          ...(this.redencionExcepcion && {
            redimirBeneficioAsistencia: false,
            redencionExcepcion: true,
            motivo,
          }),
        };
        this.loading = true;
        updateSolicitud(body, this.$route.params.idSolicitud).then((r) => {
          if (r.status == 200) {
            this.$toast.success(r.message);
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          } else {
            this.$toast.error(r.message);
            this.loading = false;
          }
        });
      }
      this.closeAllActions();
      setTimeout(() => {
        this.$router.go(0);
      }, 2000);
    },
    closeDialogSolicitud() {
      this.closeAllActions();
    },
    changeProductoLead() {
      if (
        !this.solicitudLocal.tarjeta ||
        this.solicitudLocal.tarjeta.length < 6
      ) {
        return;
      }

      const binFound = this.binesTarjetas.find((bin) =>
        this.solicitudLocal.tarjeta.startsWith(bin.bin),
      );

      if (!binFound) {
        return;
      }

      const productoFound = this.productosAdmitidos.find(
        (producto) => producto.producto_lead === binFound.nombre,
      );

      if (!productoFound) {
        return;
      }
      this.solicitudLocal.productoId = productoFound.id;
    },
    async checkBeforeSend() {
      try {
        if (this.$refs.firstStepForm.validate()) {
          const response = await getTarjetaInfo(this.solicitudLocal.tarjeta);
          if (response.success) {
            this.solicitudLocal.cliente_id = response.data.cliente_id;
            this.solicitudLocal.categoria = "Redención Normal";
            this.$emit("redencionNormal", this.solicitudLocal);
          } else {
            this.$toast.info(
              "Ingresa los datos del cliente, la redención se creará sin emisión.",
            );
            this.$toast.info(response.message);
            this.solicitudLocal.categoria = "Redención sin Emisión";
            this.$emit("redencionSinEmision", this.solicitudLocal);
          }
        }
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
    filterAsistenciaBeneficio(tipo) {
      const tipoFiltrado =
        tipo === "Redención Beneficio" ? "Beneficio" : "Asistencia";
      this.beneficios = this.beneficiosList.filter(
        (item) => item.tipo === tipoFiltrado,
      );

      if (
        this.isViewMode &&
        this.solicitudLocal.beneficioAsistencia &&
        !this.beneficios.some(
          (item) => item.id == this.solicitudLocal.beneficioAsistencia,
        )
      ) {
        this.beneficios = [
          {
            id: this.solicitudLocal.beneficioAsistencia,
            nombre:
              this.solicitudLocal.nombreAsistencia ||
              `Beneficio #${this.solicitudLocal.beneficioAsistencia}`,
            tipo: tipoFiltrado,
          },
          ...this.beneficios,
        ];
      }
    },
    handleChoice({ type, args }) {
      if (type === "eleccion") {
        const [val] = args;
        this.userChoice(val);
      } else if (type === "redencionManual") {
        const [val, folio] = args;
        this.userChoice(val, folio);
      } else if (type === "motivo") {
        const [val, motivo] = args;
        this.userChoiceMotivo(val, motivo);
      }
    },
    handleClose(type) {
      this.modals[type] = false;
    },
    handleShowFolio(folio) {
      this.folio = folio;
      this.modals.openValidateCode = false;
      this.modals.showFolio = true;
    },
  },
};
</script>

<style>
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  width: 300px;
  height: 40px !important;
  font-size: small;
  font-weight: bold;
  margin-top: 10px;
}
</style>
